import { defineComponent as M, mergeModels as x, useModel as z, inject as D, createElementBlock as l, openBlock as d, Fragment as R, createBlock as k, resolveDynamicComponent as I, unref as e, normalizeProps as j, guardReactiveProps as w, withCtx as P, createElementVNode as r, mergeProps as h, createCommentVNode as B, normalizeClass as i, createVNode as A, renderSlot as T, createTextVNode as F, toDisplayString as K } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Accordion/accordion.js";
import { AngleRightIcon as $ } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { AccordionKey as O } from "./Accordion.vue2.js";
import { useOUIAProps as U } from "../../helpers/ouia.js";
const q = ["aria-expanded"], W = /* @__PURE__ */ M({
  name: "PfAccordionItem",
  inheritAttrs: !1,
  __name: "AccordionItem",
  props: /* @__PURE__ */ x({
    title: {},
    toggleComponent: {},
    contentComponent: {},
    fixed: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ x(["click"], ["update:expanded"]),
  setup(s, { emit: b }) {
    const c = s, E = U({ id: c.ouiaId, safe: c.ouiaSafe }), a = z(s, "expanded"), N = b, n = D(O, void 0);
    function S(o) {
      a.value = !a.value, N("click", o);
    }
    return (o, p) => {
      var m, u, f, g, v;
      return d(), l(R, null, [
        (d(), k(I(o.toggleComponent || ((m = e(n)) != null && m.dl ? "dt" : typeof ((u = e(n)) == null ? void 0 : u.level) == "string" ? (f = e(n)) == null ? void 0 : f.level : `h${(g = e(n)) == null ? void 0 : g.level}`)), j(w(e(E))), {
          default: P(() => {
            var C, y;
            return [
              r("button", h(o.$attrs, {
                type: "button",
                class: [
                  e(t).accordionToggle,
                  {
                    [e(t).modifiers.expanded]: a.value
                  }
                ],
                "aria-expanded": a.value,
                onClick: p[0] || (p[0] = (V) => S(V))
              }), [
                ((C = e(n)) == null ? void 0 : C.togglePosition) === "start" ? (d(), l("span", {
                  key: 0,
                  class: i(e(t).accordionToggleIcon)
                }, [
                  A(e($))
                ], 2)) : B("", !0),
                r("span", {
                  class: i(e(t).accordionToggleText)
                }, [
                  T(o.$slots, "toggle", {}, () => [
                    F(K(o.title), 1)
                  ])
                ], 2),
                ((y = e(n)) == null ? void 0 : y.togglePosition) === "end" ? (d(), l("span", {
                  key: 1,
                  class: i(e(t).accordionToggleIcon)
                }, [
                  A(e($))
                ], 2)) : B("", !0)
              ], 16, q)
            ];
          }),
          _: 3
        }, 16)),
        (d(), k(I(o.contentComponent || ((v = e(n)) != null && v.dl ? "dd" : "div")), h(o.$attrs, {
          class: [
            e(t).accordionExpandableContent,
            {
              [e(t).modifiers.fixed]: o.fixed,
              [e(t).modifiers.expanded]: a.value
            }
          ],
          hidden: !a.value
        }), {
          default: P(() => [
            r("div", {
              class: i(e(t).accordionExpandableContentBody)
            }, [
              T(o.$slots, "default")
            ], 2)
          ]),
          _: 3
        }, 16, ["class", "hidden"]))
      ], 64);
    };
  }
});
export {
  W as default
};
